import { useEffect, useState } from "react";
import useTags, { readTagPayload, useDebouncedValue } from "api/TagResource/useTags";

export default function useTagsPage() {
	const [filters, setFilters] = useState({ search: "", sort: "name", usage: "all" });
	const search = useDebouncedValue(filters.search.trim());
	const scope = JSON.stringify([search, filters.sort, filters.usage]);
	const [pagination, setPagination] = useState({ scope: "", page: 1 });
	// A new query starts at page 1 in the same render, avoiding a request for the old page.
	const page = pagination.scope === scope ? pagination.page : 1;
	const query = useTags("yes", { search, sort: filters.sort, usage: filters.usage, page, rowsPerPage: 40 });
	const payload = readTagPayload(query.data);
	const changePage = (next) => setPagination({ scope, page: next });
	useEffect(() => {
		if (query.data && !query.isFetching && page > payload.totalPages) setPagination({ scope, page: payload.totalPages });
	}, [query.data, query.isFetching, page, payload.totalPages, scope]);
	const hasCounts = Number.isFinite(payload.usedCount) && Number.isFinite(payload.unusedCount);
	const counts = {
		total: !query.data ? undefined : hasCounts ? payload.usedCount + payload.unusedCount : !search && filters.usage === "all" ? payload.totalRecords : undefined,
		used: payload.usedCount,
		unused: payload.unusedCount,
	};
	return { ...query, filters, page, payload, counts,
		changeFilter: (name, value) => setFilters((current) => ({ ...current, [name]: value })),
		changePage, reset: () => { setFilters({ search: "", sort: "name", usage: "all" }); setPagination({ scope: "", page: 1 }); },
		hasFilters: !!filters.search.trim() || filters.usage !== "all",
	};
}
